import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import Legend from '../../../components/Accessibility/Legend/Legend';
import utils from '../../../modules/utils';
import EmailAddressWrapper from '../../../sections/AddressSection/EmailAddress/EmailAddressWrapper/EmailAddressWrapper';
import MarketingPreferencesContainer from '../../../sections/SubmitSection/MarketingPreferences/MarketingPreferencesContainer';
import {setReturnFromHostPayment} from '../../actions/site-actions';
import Translation from '../../lang/Translation';
import getIsUsingExpressCheckout from '../../selectors/ExpressSelectors/getIsUsingExpressCheckout';
import {getMarketingPreferenceExperiment, isEmailRequired} from '../../selectors/GuestSelectors';
import {
  getDeliveryType, isDeliveryTypeValid, getSiteCode,
} from '../../selectors/selectors';
import V2Components from '../../v2-components';
import AddressSection from './AddressSection/AddressSection';
import CollapsedDeliveryAddress from './AddressSection/CollapsedDeliveryAddress/CollapsedDeliveryAddress';
import AddressTypesAsTabsOrButtons from './AddressSection/AddressTypesAsTabsOrButtons';

export class DeliveryAddressSection extends Component {
  componentDidMount() {
    V2Components.register('deliverySection', this);
    
    if (this.isReturnFromHostPayment()) {
      this.props.setReturnFromHostPayment();
    }
  }
  
  componentWillUnmount() {
    V2Components.clear('deliverySection');
  }
  
  isReturnFromHostPayment = () => utils.fn.getURIParam(window.location.search, 'trade_status')
    || utils.fn.getURIParam(window.location.search, 'paymentMethod')
    || utils.fn.getURIParam(window.location.search, 'PayerID')
    || (utils.fn.getURIParam(window.location.search, 'orderToken')
      && utils.fn.getURIParam(window.location.search, 'status') === 'SUCCESS');
  
  validate = () => {
    if (!this.props.isDeliveryTypePudo) {
      return {isValid: true};
    }
    const valid = this.props.isDeliveryTypeValid;
    if (valid) {
      return {
        isValid: true,
      };
    }
    return {
      isValid: false,
      errors: [{
        fieldName: 'delivery.address.click.and.collect',
        errorCode: 'error.no.selected.location',
      }],
    };
  };

  render() {
    return (
      <>
        {this.props.isEmailRequired && <EmailAddressWrapper showCollapsedEmailAddress={this.props.isStepCollapsed} />}
        
        <div className="DeliveryAddressSection__body">
          <fieldset>
            <Legend hidden>
              <Translation optionalExtension={this.props.siteCode}>checkout.delivery.address.section.heading.text</Translation>
            </Legend>
  
            <AddressTypesAsTabsOrButtons step={this.props.step} />
            
            {this.props.isStepCollapsed ? (
              <CollapsedDeliveryAddress isPudoSelected={this.props.isDeliveryTypePudo} />
            ) : (
              <AddressSection />
            )}
          </fieldset>
        </div>
        
        {this.props.showMarketingPreferenceContainer && (
          <MarketingPreferencesContainer hasMarketingPrefInDeliverySection />
        )}
      </>
    );
  }
}

DeliveryAddressSection.propTypes = {
  step: PropTypes.number.isRequired,
  deliveryType: PropTypes.bool.isRequired,
  isDeliveryTypeValid: PropTypes.bool.isRequired,
  showMarketingPreferenceContainer: PropTypes.bool.isRequired,
  isEmailRequired: PropTypes.bool.isRequired,
  isDeliveryTypePudo: PropTypes.bool.isRequired,
  isStepCollapsed: PropTypes.bool.isRequired,
  siteCode: PropTypes.string.isRequired,
  
  // Actions
  setReturnFromHostPayment: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  siteCode: getSiteCode(state),
  isDeliveryTypeValid: isDeliveryTypeValid(state),
  isDeliveryTypePudo: getDeliveryType(state) === 'pudo',
  showMarketingPreferenceContainer: (getMarketingPreferenceExperiment(state) === 'v1|underEmailMarketingPreferences')
  && !getIsUsingExpressCheckout(state),
  isEmailRequired: isEmailRequired(state),
});

const mapDispatchToProps = {
  setReturnFromHostPayment,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryAddressSection);
